import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,[_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t(_vm.translation + (_vm.dataKey?"."+_vm.dataKey:""))))]),_c(VListItemSubtitle,{staticClass:"text-right"},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.text?_vm.text:(_vm.data && _vm.dataKey?_vm.data[_vm.dataKey] : "")))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }